import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { MODAL_KEYS } from '_constants/modals';
import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';
import { selectModalVisibleByKey } from '_store/modals/selector';
import { hideModal } from '_store/modals/slice';

import CustomSearchPannel from 'components/composed/views/ChatView/CustomSearchPannel';

const StyledModalBody = styled(Modal.Body)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  .sendbird-message-search-pannel {
    min-width: 300px;

    .sendbird-icon {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .sendbird-ui-header {
      &.sendbird-message-search-pannel__header {
        height: auto;
        min-height: unset;
        padding-bottom: ${theme.spaces.smallX}px;

        .sendbird-ui-header__middle__title.sendbird-label {
          &.sendbird-label--h-2 {
            &.sendbird-label--color-onbackground-1 {
              color: ${theme.colors.gray.primary};
            }
          }
        }

        .sendbird-icon {
          &.sendbird-icon-close {
            &.sendbird-icon-color--on-background-1 {
              svg {
                path {
                  fill: ${theme.colors.gray.primary};
                }
              }
            }
          }
        }
      }
    }

    .sendbird-message-search-pannel__input__container {
      border: 2px solid ${theme.colors.gray.secondary} !important;
      border-radius: 12px;
      box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);

      .sendbird-message-search-pannel__input__container__search-icon {
        left: ${theme.spaces.smallX}px !important;
      }

      .sendbird-message-search-pannel__input__container__input-area {
        top: 10px;
        left: 38px;
        width: calc(100% - 80px);
      }

      .sendbird-message-search-pannel__input__container__reset-input-button {
        top: 10px;
        right: 10px !important;
      }

      .sendbird-message-search-pannel__input__container__spinner {
        top: 10px;
        right: 10px !important;
      }
    }

    .sendbird-message-search {
      overflow-y: auto;

      .sendbird-message-search-item {
        &.sendbird-message-search-item--selected {
          background-color: ${hexToRGBA(theme.colors.indigo.primary, 0.08)};
        }

        .sendbird-message-search-item__left {
          border-inline-start: none;

          .sendbird-avatar-img {
            &.sendbird-image-renderer {
              top: 0;
            }

            .sendbird-avatar-img--default {
              background-color: ${theme.colors.indigo.light};
            }
          }
        }

        .sendbird-message-search-item__right {
          .sendbird-message-search-item__right__message-created-at {
            right: 16px;
          }
        }
      }
    }
  }
`;

const ChatMessageSearchModal = () => {
  const dispatch = useDispatch();
  const visible = useSelector(selectModalVisibleByKey(MODAL_KEYS.chatMessageSearch));

  const handleClose = () => {
    dispatch(hideModal({ key: MODAL_KEYS.chatMessageSearch }));
  };

  return (
    <Modal
      dialogClassName="statement-delete-confirmation-modal"
      size="sm"
      show={visible}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <StyledModalBody>
        <CustomSearchPannel />
      </StyledModalBody>
    </Modal>
  );
};

export default ChatMessageSearchModal;
